import {
  SET_COURSE_DETAIL_DATA,
  COURSES_LOADER,
  DOWNLOAD_COUNT,
  SET_COURSES_DATA,
  SET_PROGRAMS_DATA,
  SET_CONFERENCES_DATA,
  SET_SEMINARS_DATA,
  SET_ALL_DATA,
} from "../actionTypes";

const initialState = {
  loader: false,
  courseDetail: {},
  courses: {},
  seminars: {},
  programs: {},
  conferences: {},
  all: {},
};

const coursesReducer = (state = initialState, action) => {
  switch (action.type) {
    case COURSES_LOADER:
      return {
        ...state,
        loader: action.payload,
      };
    case SET_COURSES_DATA: {
      return {
        ...state,
        courses: action.payload,
      };
    }
    case SET_SEMINARS_DATA: {
      return {
        ...state,
        seminars: action.payload,
      };
    }
    case SET_CONFERENCES_DATA: {
      return {
        ...state,
        conferences: action.payload,
      };
    }
    case SET_ALL_DATA: {
      return {
        ...state,
        all: action.payload,
      };
    }
    case SET_PROGRAMS_DATA: {
      return {
        ...state,
        programs: action.payload,
      };
    }
    case SET_COURSE_DETAIL_DATA: {
      return {
        ...state,
        courseDetail: action.payload,
      };
    }
    // case DOWNLOAD_COUNT: {
    //   if (action.payload == "fileview") {
    //     return {
    //       ...state,
    //       courseDetail: {
    //         ...state.courseDetail,
    //         fileViewCount: (state.courseDetail?.fileViewCount || 0) + 1,
    //       },
    //     };
    //   } else
    //     return {
    //       ...state,
    //       courseDetail: {
    //         ...state.courseDetail,
    //         downloadCount: (state.courseDetail?.downloadCount || 0) + 1,
    //       },
    //     };
    // }
    default:
      return state;
  }
};

export default coursesReducer;
